<div class="p-2" *ngrxLet="vm$$; let vm" data-uit="notifications-list">
    <h4>{{ 'NOTIFICATIONS.TITLE' | translate }}</h4>
    <ca-notification-item
        *ngFor="let item of vm.notifications$ | keyvalue"
        [title]="item.value.title"
        [text]="item.value.text"
        [severity]="item.value.severity"
    ></ca-notification-item>
</div>
